<template>
	<div class="container__registers">
		<label class="title_planning">{{ `${$t('planningPrognosis')} / ${item.descricao}` }}</label>
		<div
			v-if="processandoPrognose"
			class="progresso-job"
		>
			<Spinner class="progresso-job__spinner" />
			<div class="progresso-job__info">
				<span class="progresso-job__titulo">{{ $t('processamentoEmAndamento') }}</span>
				<span class="progresso-job__etapa">
					{{ progressoJob.etapa || $t('aguardandoInicioProcessamento') }}
					<template v-if="progressoJob.renderTotal > 0">
						— {{ progressoJob.renderFeitos }}/{{ progressoJob.renderTotal }}
					</template>
				</span>
				<div
					v-if="progressoJob.renderTotal > 0"
					class="progresso-job__barra"
				>
					<div
						class="progresso-job__barra-preenchida"
						:style="{ width: `${(progressoJob.renderFeitos / progressoJob.renderTotal) * 100}%` }"
					/>
				</div>
			</div>
		</div>
		<div class="container__main">
			<Card class="container__filtragem">
				<Filtragem
					ref="filtragem"
					:variavel-bio="enableButton && modeloVariavel.length ? true : false"
					:is-prognose="true"
					:variavel-grafico="variavelDeInteresse"
					:value="filtros"
					:disable-value="modelos.length ? false : true"
					:set-loading="loading"
					:set-color="color"
					:esta-apenas-visualizando-o-resultado="isEdit == 'true' || !!$route.query.jobId"
					:processando-job="processandoPrognose"
					@filtroConfig="setFiltroConfig($event)"
					@filtroAplicado="filtroAplicado = $event"
					@metaAmostragem="metaAmostragem = $event"
					@filtrar="filtrarParcelas"
					@processar="processar"
					@buscando="setBuscando"
					@filtrando="filtrando = $event"
				/>
			</Card>
			<Card
				v-if="modelagemStatus"
				:key="flag"
				class="container__dashboard__contentbody__card"
			>
				<div
					v-if="!agrupamentos?.length"
					class="flex h-full items-center justify-center"
				>
					<div v-if="filtrando">
						<Spinner />
					</div>
					<div
						v-else
						style="
							color: rgb(149, 187, 73);
							text-align: center;
							vertical-align: bottom;
							font-weight: 800;
						"
					>
						{{ agrupamentos ? $t('filtragemNaoRetornouDados') : $t('selecioneOsFiltros') }}
					</div>
				</div>
				<ScatterChart
					v-else
					:key="rerender"
					:select-on-zoom="selectArea"
					:options="item.variaveisBiometricas || []"
					:mostrar-texto="isEdit"
					:maximo-variavel="maximoVariavelInteresse"
					class="main__parcels__chart"
					:idade-referencia="Number(item.clst_nr_idade_referencia)"
					:curvas="curvas"
					:series="seriesGrafico"
					:tipo="variavelDeInteresse"
					:updated-at="buscando"
					@selectedPoints="selectedPoints"
					@tipoGrafico="tipoDoGrafico"
				>
					<template
						v-if="graficoBuscaAmostrado"
						#subtitle-prefix
					>
						<span
							class="badge__amostra"
							:title="tooltipAmostraBusca"
						>
							<i class="fas fa-info-circle"></i>
							Amostra de {{ seriesGrafico.length.toLocaleString() }} de
							{{
								(metaAmostragem
									? metaAmostragem.totalPontos
									: seriesGrafico.length
								).toLocaleString()
							}}
							pontos
						</span>
					</template>
					<template #action-buttons>
						<div class="action__buttons">
							<div class="action__buttons_left">
								<Button
									v-show="!flag"
									:label="`${$t('deleteSelected')}  ${parcelasTemporarias.length ? '( ' + parcelasTemporarias.length + ' )' : ''}`"
									color="trv-secondary"
									icon="far fa-trash-alt"
									semantic-class="tiny"
									:disabled="parcelasTemporarias.length === 0"
									width-auto
									@click="removeParcelasSelecionadas"
								/>

								<Button
									v-show="!flag"
									:label="$t('restoreDeleted')"
									color="trv-secondary"
									icon="fas fa-undo-alt"
									semantic-class="tiny"
									:disabled="parcelasBkp.length === parcelas.length"
									width-auto
									outlined
									@click="parcelas = parcelasBkp"
								/>
							</div>
							<div class="action__buttons_right">
								<p>{{ quantidadeParcelas }} Parcelas</p>
								<p>{{ quantidadePlantios }} Plantios</p>
								<Button
									v-show="flag"
									:label="$t('seeModel')"
									color="trv-primary"
									semantic-class="tiny"
									width-auto
									@click="modelagemStatus = false"
								/>
							</div>
						</div>
					</template>
				</ScatterChart>
			</Card>

			<Card v-else>
				<div class="model__preview__container">
					<Tag
						class="tag_cabecalho_modelo"
						class-name="default outlined"
						:label="
							item.analisesEstatisticas
								? tipoInfoGrafico.label
								: `${$t('chooseAModelTo')} ${tipoInfoGrafico.label}`
						"
					/>
					<ModelPreview
						:key="variavelDeInteresse"
						:tipo-info-grafico="tipoInfoGrafico"
						:model="modeloEscolhido"
						:preview-mode="flag"
						@back="fechaVisualizacaoModelo"
						@modeln="lidaEvento"
						@click="defineModelo"
					>
						<div
							v-if="!item.analisesEstatisticas"
							class="model__preview_actions"
						>
							<Button
								v-if="!flag"
								icon="fas fa-caret-left"
								:disabled="modeln == 0"
								class="btnnn"
								color="trv-primary"
								@click="anterior"
							/>
							<Button
								v-if="!flag"
								:id="model.stan_nm_variavel_modelo"
								class="btnVoltar"
								:loading="escolherModeloLoading"
								:label="`${$t('pickModel')} (${modeln + 1 + '/' + modelos.length})`"
								@click="defineModelo"
							/>
							<Button
								v-else
								:id="model.stan_nm_variavel_modelo"
								:label="$t('back')"
								@click="fechaVisualizacaoModelo"
							/>
							<Button
								v-if="!flag"
								id="btnProx"
								:disabled="modeln == modelos.length - 1"
								icon="fas fa-caret-right"
								class="btnnn"
								color="trv-primary"
								@click="proximo"
							/>
						</div>
					</ModelPreview>
				</div>
			</Card>

			<Card>
				<div
					v-if="carregandoClassificacaoDeSitio || prognoseSemClassificacaoDeSitioAtrelada"
					class="info_classificacao_de_sitio_title"
					style="padding: 1rem; text-align: center"
				>
					<label v-if="carregandoClassificacaoDeSitio">{{ $t('aguarde') }}</label>
					<label v-else-if="prognoseSemClassificacaoDeSitioAtrelada">{{
						$t('prognoseSemCSAtrelada')
					}}</label>
				</div>

				<div
					v-else-if="modelagemStatus"
					class="info_classificacao_de_sitio"
				>
					<div class="info_classificacao_de_sitio_title">
						<label>{{ $t('siteClassification') }}</label>
					</div>

					<div class="info_classificacao_de_sitio_details">
						<div class="info_classificacao_de_sitio_subtitle">
							<label>{{ $t('filtrosUtilizados') }}</label>
							<Tooltip
								titulo="Prognose"
								subtitulo="Filtros da Classificação de Sítio"
								:conteudo="$t('dadosUsadosNaFiltragem')"
							/>
						</div>
						<div class="info_classificacao_de_sitio_info">
							<label v-show="filtroClassificacaoDeSitio.fazenda?.length"
								>{{ $t('farms') }}:
								<span>{{ filtroClassificacaoDeSitio.fazenda?.join(' / ') }}</span></label
							>
							<label v-show="filtroClassificacaoDeSitio.estrato?.length"
								>{{ $t('stratums') }}:
								<span>{{ filtroClassificacaoDeSitio.estrato?.join(' / ') }}</span></label
							>
							<label v-show="filtroClassificacaoDeSitio.espacamentos?.length"
								>{{ $t('espacamentos') }}:
								<span>{{ filtroClassificacaoDeSitio.espacamentos?.join(' / ') }}</span></label
							>
							<label v-show="filtroClassificacaoDeSitio.idadesPlantio?.length"
								>{{ $t('idadeDosPlantios') }}:
								<span>{{ filtroClassificacaoDeSitio.idadesPlantio?.join(' / ') }}</span></label
							>
							<label v-show="filtroClassificacaoDeSitio.datasDePlantio?.length"
								>{{ $t('dataDosPlantios') }}:
								<span>{{ filtroClassificacaoDeSitio.datasDePlantio?.join(' / ') }}</span></label
							>
							<label v-show="filtroClassificacaoDeSitio.especies?.length"
								>{{ $t('species') }}:
								<span>{{ filtroClassificacaoDeSitio.especies?.join(' / ') }}</span></label
							>
							<label v-show="filtroClassificacaoDeSitio.materialGenetico?.length"
								>{{ $t('materiaisGeneticos') }}:
								<span>{{ filtroClassificacaoDeSitio.materialGenetico?.join(' / ') }}</span></label
							>
							<label
								>{{ $t('singleTrees') }}:
								<span>{{
									filtroClassificacaoDeSitio.singleTrees ? 'Com Single-Trees' : 'Sem Single-Trees'
								}}</span></label
							>
						</div>

						<div class="info_classificacao_de_sitio_subtitle">
							<label>{{ $t('estatisticasGeradas') }}</label>
							<Tooltip
								titulo="Prognose"
								subtitulo="Estatísticas da Classificação de Sítio"
								:conteudo="$t('dadosEstatisticosCS')"
							/>
						</div>
						<div class="info_classificacao_de_sitio_info">
							<label
								>{{ $t('modelName') }}:
								<span>{{ item?.parametros?.nomeModeloFormatado }}</span></label
							>
							<label
								>{{ $t('variavelDeInteresse') }}:
								<span>{{ variavelBiometricaDaClassificacaoDeSitio }}</span></label
							>
							<label
								>{{ $t('referenceAge') }}:
								<span>{{ item?.parametros?.idadeDeReferencia }}</span></label
							>
							<label
								>{{ $t('diffClassesNumber') }}:
								<span>{{ item?.parametros?.numeroDeClasses }}</span></label
							>
							<label
								>{{ $t('lowerLimit') }}: <span>{{ item?.parametros?.limiteInferior }}</span></label
							>
							<label
								>{{ $t('upperLimit') }}: <span>{{ item?.parametros?.limiteSuperior }}</span></label
							>
						</div>
					</div>
				</div>

				<div
					v-else
					class="info_planejamento_prognose"
				>
					<div class="abas_planejamento_estatistica">
						<v-tabs
							v-model="tab"
							align-with-title
							color="#95bb49"
							centered
						>
							<v-tab>{{ $t('planning') }}</v-tab>
							<v-tab> + {{ $t('statistics') }}</v-tab>
						</v-tabs>
						<v-tabs-items v-model="tab">
							<v-tab-item>
								<p v-if="modeloVariavel.length === 0">
									{{ $t('escolhaUmModelo') }}
								</p>
								<div class="container__cards__variavel__modelo">
									<Card
										v-for="vm in modeloVariavel"
										:id="vm.variavel"
										:key="vm.variavel"
										class="card_variavel_modelo"
										:highlight="vm.variavel === tipoInfoGrafico.label"
										@click="retornaVariavelModelo($event)"
									>
										<Tag
											v-if="vm.sugerido"
											:id="vm.variavel"
											label="sugerido"
											class="tag__modelo__sugerido"
											class-name="default"
										/>
										<p
											:id="vm.variavel"
											class="relacao__variavel__modelo"
										>
											{{ `${vm.variavel}: ${vm.modelo}` }}
										</p>
									</Card>
								</div>
							</v-tab-item>
							<v-tab-item>
								<AboutModel
									v-show="!modelagemStatus"
									:key="variavelDeInteresse + modeloEscolhido.stan_nm_titulo_modelo"
									:modelo-escolhido="modeloEscolhido"
									:formula="formula"
								/>
							</v-tab-item>
						</v-tabs-items>
					</div>

					<div class="container__button__classificar">
						<Button
							v-show="!modelagemStatus"
							:disabled="item.analisesEstatisticas && modeloVariavel.length > 0"
							:label="$t('save')"
							:loading="savePlanejamentoLoading"
							@click="salvar"
						/>
					</div>
				</div>
			</Card>
		</div>
	</div>
</template>
<script>
import { mapMutations } from 'vuex'
import AboutModel from '../../../components/AboutModel/AboutModel.vue'
import Button from '../../../components/Button/Button'
import Card from '../../../components/Card/Card'
import ModelPreview from '../../../components/ModelPreview/ModelPreview'
import Filtragem from '../../../components/Prognose/Planejamento/Filtragem'
import ScatterChart from '../../../components/ScatterChart/ScatterChart'
import Spinner from '../../../components/Spinner/Spinner'
import Tag from '../../../components/Tag/Tag'
import Tooltip from '../../../components/Tooltip/Tooltip'

import { prognose } from '../../../utils/variaveisBiometricas'

import { getParametrosById } from '../../../services/requests/ClassificacaoSitioRequests'

import {
	enfileirarProcessamentoPrognose,
	statusProcessamentoPrognose,
	excluirProcessamentoPrognose,
	getPrognosePorId,
	salvarPlanejamento,
} from '../../../services/requests/PrognoseRequests'

import modelos from '../../../services/responses/classificacaoSitio/modelos'

export default {
	name: 'PlanejamentoPrognose',
	data() {
		return {
			filtrando: false,
			savePlanejamentoLoading: false,
			escolherModeloLoading: false,
			enableButton: true,
			isEdit: '',
			modelosPrognose: [],
			indiceVariavel: 0,
			modeloVariavel: [],
			sitios: [],
			classeParcela: [],
			mudancaClasses: [],
			parcelaSitio: [],
			filtros: {
				ciclos: [],
				cidades: [],
				datasMedicao: [],
				datasPlantio: [],
				enableHistoricalData: [],
				espacamentos: [],
				especiesIds: [],
				estados: [],
				estratosIds: [],
				fazendasIds: [],
				idadesPlantio: [],
				isSingleTrees: false,
				manejos: [],
				materiaisGeneticos: [],
				paises: [],
				parcelasIds: [],
				plantiosIds: [],
				rotacoes: [],
				selectedDataPlantio: [],
				selectedIdadePlantio: [],
				talhoesIds: [],
				tiposServicos: [],
				variaveis: [],
			},
			rerender: true,
			booleanDisable: false,
			infoGrafico: {},
			flag: false,
			valuedisabled: false,
			equacao: true,
			selectArea: false,
			disableBuscar: false,
			interval: 60000,
			dadosModelo: [],
			modeloEscolhido: { stan_nm_variavel_modelo: 'default' },
			contador: undefined,
			modelosCalculados: [],
			loading: false,
			carregandoClassificacaoDeSitio: true,
			prognoseSemClassificacaoDeSitioAtrelada: false,
			tt: '',
			valueSave: false,
			modelos: modelos.sort((a, b) =>
				a.stan_md_erro_porcentagem > b.stan_md_erro_porcentagem ? 1 : -1,
			),
			color: 'trv-default',
			item: {
				clst_nr_curvas: '',
				clst_nr_idade_referencia: '',
				clst_md_limite_superior: '',
				clst_md_limite_inferior: '',
				clst_nr_amplitude_classes: '',
				variaveisEscolhidas: [],
				parametros: {
					coeficientes: [],
					idadeDeReferencia: '',
					limiteInferior: '',
					limiteSuperior: '',
					nomeModelo: '',
					numeroDeClasses: '',
					variavelDeInteresse: '',
					filtroDasAmostras: '',
				},
			},
			buscando: '',
			// Filtro aplicado na última busca (emitido por Filtragem). Reaproveitado
			// no processar por filtro (fluxo D) para mandar só o filtro ao back.
			filtroAplicado: null,
			// Metadados da busca reduzida (vêm do back): totais sobre os dados reais.
			metaAmostragem: null,
			// Indica que há um job de processamento de prognose em andamento (polling).
			processandoPrognose: false,
			// Progresso do job (vem do status): etapa do worker + contador do render.
			progressoJob: { etapa: null, renderFeitos: 0, renderTotal: 0 },
			// Job cujo resultado está na tela — ao salvar o planejamento, o job é
			// removido da central de processamentos (histórico não precisa mais dele).
			jobIdProcessamento: null,
			// Setado no beforeDestroy: encerra o loop de polling ao sair da tela.
			// Sem isso o loop rodava até 20min segurando o componente DESTRUÍDO
			// inteiro na memória (parcelas, modelos, filtros) — vazamento que
			// acumulava a cada entra-e-sai e pressionava o heap do navegador.
			pollingCancelado: false,
			parcelasTemporarias: [],
			parcelas: [],
			parcelasBkp: [],
			variavelDeInteresse: '',
			modeln: 0,
			colors: ['primary', 'secondary', 'yellow darken-2', 'red', 'orange'],
			disabledInput: true,
			modelagemStatus: true,
			showHistogramas: false,
			dropdownDownload: '',
			dropdownTipoGrafico: 'dispersaoParcelas',
			label: 'planejamento',
			estratos: [],
			model: 'tab-1',
			tab: null,
			text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		}
	},
	computed: {
		filtroClassificacaoDeSitio() {
			return {
				fazenda: this.item.parametros.filtroDasAmostras.fazendasIds?.map((fazenda) => fazenda.nome),
				estrato: this.item.parametros.filtroDasAmostras.estratosIds?.map(
					(estrato) => estrato.descricao,
				),
				datasDePlantio: this.item.parametros.filtroDasAmostras.datasPlantio?.map(
					(dataPlantio) => dataPlantio.label,
				),
				idadesPlantio: this.item.parametros.filtroDasAmostras.idadesPlantio?.map(
					(idadePlantio) => idadePlantio.label,
				),
				materialGenetico: this.item.parametros.filtroDasAmostras.materiaisGeneticos?.map(
					(idadePlantio) => idadePlantio.label,
				),
				especies: this.item.parametros.filtroDasAmostras.especiesIds?.map(
					(especie) => especie.label,
				),
				espacamentos: this.item.parametros.filtroDasAmostras.espacamentos?.map(
					(espacamento) => espacamento.label,
				),
				singleTrees: this.item.parametros.filtroDasAmostras.isSingleTrees,
			}
		},
		variavelBiometricaDaClassificacaoDeSitio() {
			return prognose.find(
				(prognose) => prognose.enum === this.item?.parametros?.variavelDeInteresse,
			)?.label
		},
		tipoInfoGrafico() {
			return this.biovars.find((f) => f.value === this.variavelDeInteresse)
		},
		biovars() {
			return prognose
		},
		modelosVariaveis() {
			return this.modeloVariavel.map((m) => {
				return {
					variavel: m.variavel,

					modelo: this.item.analisesEstatisticas
						? m.modelo
						: this.modelos.find((f) => f.stan_nm_variavel_modelo === m.modelo)
								.stan_nm_titulo_modelo,
				}
			})
		},
		maximoVariavelInteresse() {
			// reduce (sem spread) — Math.max.apply/spread sobre this.parcelas (centenas
			// de milhares de pontos) estoura "Maximum call stack size exceeded".
			const chave = this.tipoInfoGrafico.value
			return this.parcelas.reduce((max, m) => (m[chave] > max ? m[chave] : max), -Infinity)
		},
		formula() {
			const modelo = this.modeloEscolhido
			const variavelModelo = modelo?.stan_nm_variavel_modelo || ''
			const tituloModelo = modelo?.stan_nm_titulo_modelo || ''
			const ehClutterBasalArea =
				variavelModelo === 'ClutterBasalAreaModel' ||
				/Clutter.*Basal/i.test(variavelModelo) ||
				/Clutter.*Basal/i.test(tituloModelo)

			const formulaPadrao =
				'$$\\large variavelInteresse =\\beta_1 \\left(1-e^{\\beta _2I^{\\beta _3}}\\right)$$'
			const formulaClutterBasalArea =
				'$$\\scriptsize\\begin{cases} \\ln(variavelInteresse) = b_0 + b_1 S + \\frac{b_2}{I_2} + b_3 \\ln(B_2)\\\\ \\ln(B_2) = \\ln(B_1)\\left(\\frac{I_1}{I_2}\\right) + a_1\\left(1-\\frac{I_1}{I_2}\\right) + a_2\\left(1-\\frac{I_1}{I_2}\\right)S \\end{cases}$$'

			const formulaBruta = ehClutterBasalArea
				? formulaClutterBasalArea
				: modelo?.stan_nm_formula_modelo || formulaPadrao

			return formulaBruta.replaceAll('variavelInteresse', this.tipoInfoGrafico?.latex)
		},
		quantidadeClassesParcela() {
			if (this.modeloInfo) {
				let d = this.modeloInfo?.informacoesHistogramas?.quantidadeClassesParcela
					.map((m) => m.quantidadeClasses)
					.reduce((acc, item) => {
						acc[item] = (acc[item] || 0) + 1
						return acc
					}, {})
				var total = this.modeloInfo?.informacoesHistogramas?.quantidadeClassesParcela.length
				var serie = Object.entries(d)

				serie.forEach((f) => {
					f[2] = (f[1] / total) * 100
					console.log(f)
				})
				return serie
			} else {
				return this.classeParcela
			}
		},

		quantidadeParcelaSitio() {
			let d = this.parcelaSitio.length
				? this.parcelaSitio
				: !this.modeloInfo
					? []
					: this.modeloInfo?.informacoesHistogramas?.quantidadeParcelaSitio.map((m) => [
							m.indiceSitio,
							m.quantidadeParcelas,
						])
			var total = this.modeloInfo?.informacoesHistogramas?.quantidadeClassesParcela.length
				? this.modeloInfo?.informacoesHistogramas?.quantidadeClassesParcela.length
				: this.quantidadeParcelas

			d.forEach((f) => {
				f[2] = (f[1] / total) * 100
			})
			return d
		},

		quantidadeMudancaClassesParcela() {
			if (this.modeloInfo) {
				let d = this.modeloInfo?.informacoesHistogramas?.quantidadeMudancaClassesParcela
					.map((m) => m.mudancasClasses)
					.reduce((acc, item) => {
						acc[item] = (acc[item] || 0) + 1
						return acc
					}, {})
				var total = this.modeloInfo?.informacoesHistogramas?.quantidadeClassesParcela.length
				var serie = Object.entries(d)

				serie.forEach((f) => {
					f[2] = (f[1] / total) * 100
				})
				return serie
			} else {
				return this.mudancaClasses
			}
		},

		curvas() {
			return this.sitios.length
				? this.sitios
				: !this.modeloInfo
					? []
					: this.modeloInfo?.curvasSitio?.map((curva) => {
							return {
								tooltip: {
									positioner: function () {
										return { x: 40, y: 25 }
									},
									headerFormat: '<b>{point.codigoParcela}</b><br>',
									pointFormat:
										'Idade' +
										': {point.x:.0f} meses<br>' +
										this.tipoInfoGrafico.label +
										': {point.y:.3f} ' +
										this.tipoInfoGrafico.unidade.replace('(', '').replace(')', '') +
										'<br>' +
										this.tipoInfoGrafico.label +
										` referência : ${curva.identificador.toFixed(3)} ` +
										this.tipoInfoGrafico.unidade.replace('(', '').replace(')', ''),
								},
								type: 'spline',
								name: `Sítio: ${curva.identificador}`,
								data: curva.pontos.map((ponto) => {
									return {
										x: ponto.idade,
										y: Number(ponto.variavelBiometrica.toFixed(2)),
									}
								}),
							}
						})
		},

		modeloInfo() {
			return !this.modeloEscolhido
				? undefined
				: this.dadosModelo.find(
						(modelo) => modelo.modelo === this.modeloEscolhido.stan_nm_variavel_modelo,
					)
		},

		indexChosenModel() {
			return !this.modeloEscolhido ? undefined : this.modelos.indexOf(this.modeloEscolhido)
		},

		limiteSuperior() {
			return Math.max.apply(
				null,
				this.modeloInfo ? this.modeloInfo.curvasSitio.map((m) => m.identificador) : [0],
			)
		},

		limiteInferior() {
			return Math.min.apply(
				null,
				this.modeloInfo ? this.modeloInfo.curvasSitio.map((m) => m.identificador) : [0],
			)
		},

		idadeMaxima() {
			// reduce (sem spread) — ver maximoVariavelInteresse.
			return this.parcelas.reduce((max, p) => (p.idade > max ? p.idade : max), -Infinity)
		},

		quantidadeParcelas() {
			// Conta sobre os dados REAIS (total do back), não sobre a amostra do gráfico.
			if (this.metaAmostragem?.totalParcelas != null) return this.metaAmostragem.totalParcelas
			return [...new Set(this.parcelas.filter((el) => !el.isSingleTrees).map((m) => m.id))].length
		},

		quantidadePlantios() {
			if (this.metaAmostragem?.totalPlantios != null) return this.metaAmostragem.totalPlantios
			return [...new Set(this.parcelas.filter((el) => el.isSingleTrees).map((p) => p.id))].length
		},

		agrupamentos() {
			return this.parcelas
		},

		// Série do gráfico da busca: amostra representativa quando há muitos pontos
		// (this.parcelas continua íntegro para Processar/Salvar). Mesma regra da
		// tela de Classificação de Sítio.
		seriesGrafico() {
			return this.amostrarParcelasGrafico(this.parcelas) || []
		},

		graficoBuscaAmostrado() {
			// Mostra o badge só quando o back de fato reduziu (total real > exibidos).
			return (this.metaAmostragem?.totalPontos || 0) > this.seriesGrafico.length
		},

		tooltipAmostraBusca() {
			return (
				'Para manter a performance, o gráfico exibe uma amostra representativa ' +
				'dos pontos (agrupada por faixa de idade, preservando os extremos de cada faixa). ' +
				'O processamento usa TODOS os pontos — a amostra afeta apenas a visualização.'
			)
		},

		unicas() {
			return [...new Set(this.parcelas.map((m) => m.id))]
		},

		preparaPlanejamento() {
			var modelosEVariavelDeInteresse = []

			this.modeloVariavel.forEach(async (f) => {
				var modelos = await this.modelosPrognose.find(
					(ff) => prognose.find((fff) => fff.label === f.variavel).enum === ff.variavelDeInteresse,
				).analisesEstatisticas

				await modelosEVariavelDeInteresse.push(
					modelos
						.filter((ff) => ff.stan_nm_titulo_modelo === f.modelo)
						.map((m) => {
							return {
								coeficienteAssimetria: m.stan_md_coeficiente_assimetria,
								coeficienteCurtose: m.stan_md_coeficiente_curtose,
								erro: m.stan_md_erro,
								erroPorcentagem: m.stan_md_erro_porcentagem,
								r2Ajustado: m.stan_md_r2ajustado,
								modelo: this.modelos.find((modelo) => modelo.stan_nm_titulo_modelo === f.modelo)
									.stan_nm_variavel_modelo, //ModelosPrognose[f.modelo],
								variavelDeInteresse: prognose.find((ff) => ff.label === f.variavel).enum,
								dadosDoGrafico: JSON.stringify(m.graficosModelo),
								coeficientes: JSON.stringify(m.parametros),
							}
						})[0],
				)
			})

			return {
				descricao: this.item.descricao,
				filtroDasAmostras: JSON.stringify(this.filtroConfig),
				classificacaoDeSitioId: this.item.classificacaoDeSitioId,
				modelosEVariavelDeInteresse,
			}
		},
	},
	watch: {
		selectArea(e) {
			console.log(e)
			this.rerender = !this.rerender
			if (e == false) {
				this.parcelasTemporarias.length = 0
			}
		},
		modeloEscolhido() {
			this.modeln =
				this.modelos.indexOf(this.modeloEscolhido) === -1
					? 0
					: this.modelos.indexOf(this.modeloEscolhido)
			this.parcelas = this.agrupamentos
			this.item.clst_md_limite_superior = this.limiteSuperior
			this.item.clst_md_limite_inferior = this.limiteInferior
		},

		'item.clst_md_limite_superior': function () {
			this.item.clst_nr_amplitude_classes =
				(Number(this.item.clst_md_limite_superior) - Number(this.item.clst_md_limite_inferior)) /
				Number(this.item.clst_nr_curvas)
		},

		'item.clst_md_limite_inferior': function () {
			this.item.clst_nr_amplitude_classes =
				(Number(this.item.clst_md_limite_superior) - Number(this.item.clst_md_limite_inferior)) /
				Number(this.item.clst_nr_curvas)
		},

		'item.clst_nr_curvas': function () {
			this.item.clst_nr_amplitude_classes =
				(Number(this.item.clst_md_limite_superior) - Number(this.item.clst_md_limite_inferior)) /
				Number(this.item.clst_nr_curvas)
		},

		'item.clst_nr_amplitude_classes': function () {
			this.item.clst_nr_curvas = Math.round(
				(Number(this.item.clst_md_limite_superior) - Number(this.item.clst_md_limite_inferior)) /
					Number(this.item.clst_nr_amplitude_classes),
			)
		},
	},
	async created() {
		this.isEdit = localStorage.getItem('isEdit', this.isEdit)

		this.item = Object.assign(
			JSON.parse(localStorage.getItem('item-planejamento-prognose') || 'null') || {},
			this.item,
		)

		// Modo edição só com analisesEstatisticas NÃO-VAZIO: o cleanModel da grid
		// deixa [] (truthy!) ao criar depois de um visualizar — e o ramo de edição
		// com item de criação estourava (getPrognosePorId 400 + JSON.parse de '').
		if (this.item.analisesEstatisticas?.length) {
			try {
				const { data: prognose } = await getPrognosePorId(this.$router.history.current.params.id)
				this.item = prognose
			} catch (error) {
				// console.err não existe (estourava o próprio catch). Em edição um erro
				// aqui é real — loga e avisa o usuário em vez de mascarar.
				console.error('Erro ao carregar prognose:', error)
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: this.$t('erroAoCarregarPlanejamento'),
					messageIcon: 'far fa-times-circle',
					messageType: 'error',
				})
			}

			// Um filtro ilegível não pode matar o created() inteiro (tela em branco).
			try {
				this.filtros = JSON.parse(this.item.filtroDasAmostras)
			} catch (e) {
				console.warn('filtroDasAmostras ilegível, seguindo sem os filtros salvos:', e)
			}
			// Freeze raso (ver nota em processar): mantém pontos mutáveis pro gráfico.
			this.modelosPrognose = Object.freeze(this.item.analisesEstatisticas)

			this.item.variaveisBiometricas = prognose.filter((f) =>
				this.item.analisesEstatisticas.map((m) => m.variavelDeInteresse).includes(f.enum),
			)

			this.modeloVariavel = this.item.analisesEstatisticas.map((m) => {
				return {
					modelo: m.modelo,
					variavel: this.item.variaveisBiometricas.find((f) => f.enum === m.variavelDeInteresse)
						.label,
				}
			})

			this.variavelDeInteresse = this.item.variaveisBiometricas[0]?.value

			this.modelos = [
				this.modelosPrognose.find((f) => f.variavelDeInteresse === this.tipoInfoGrafico.enum),
			]
			this.modeloEscolhido = this.modelos.map((m) => this.formataModelo(m))[0]
			this.modelagemStatus = false
		} else {
			this.variavelDeInteresse = this.item.variaveisBiometricas[0]?.value || 'alturaDominante'

			// if (this.item.classificacaoDeSitioId) {
			//   await getParametrosById(this.item.classificacaoDeSitioId).then(
			//     (response) => {
			//       this.item.parametros = response.data;
			//       this.item.parametros.filtroDasAmostras = JSON.parse(this.item.filtroDasAmostras);
			//       this.carregandoClassificacaoDeSitio = false;
			//       this.filtros = this.item.parametros.filtroDasAmostras
			//     }
			//   );
			// } else {
			//   this.carregandoClassificacaoDeSitio = false;
			//   this.prognoseSemClassificacaoDeSitioAtrelada = true;
			// }
		}
		if (
			this.item.classificacaoDeSitioId !== undefined &&
			this.item.classificacaoDeSitioId !== null &&
			this.item.classificacaoDeSitioId !== '00000000-0000-0000-0000-000000000000'
		) {
			await getParametrosById(this.item.classificacaoDeSitioId)
				.then((response) => {
					this.item.parametros = response.data
					if (this.item.parametros.filtroDasAmostras !== undefined) {
						this.item.parametros.filtroDasAmostras = JSON.parse(
							this.item.parametros.filtroDasAmostras,
						)
					}
					this.carregandoClassificacaoDeSitio = false
					this.filtros = this.item.parametros.filtroDasAmostras
				})
				.catch((error) => {
					console.error('Erro ao obter parâmetros:', error)
				})
		} else {
			this.carregandoClassificacaoDeSitio = false
			this.prognoseSemClassificacaoDeSitioAtrelada = true
		}
		console.log(this.item.filtroDasAmostras)

		this.$once('hook:beforeDestroy', () => {
			this.pollingCancelado = true
		})

		// Vindo da central de processamentos (?jobId=...): retoma o acompanhamento do
		// job (ou carrega o resultado, se já concluiu). A central já restaurou o
		// item/filtros no localStorage antes de navegar (mesmo caminho do goToPlanejamento).
		if (this.$route.query.jobId) {
			this.retomarProcessamento(this.$route.query.jobId)
		}
	},

	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),
		// Amostra representativa para o gráfico (só visual): agrupa por faixa de
		// idade (6 meses), preserva as caudas de cada faixa (±2,5 DP da variável de
		// interesse) e sorteia o miolo até o teto. Só atua acima do limite.
		// this.parcelas continua íntegro para Processar/Salvar.
		amostrarParcelasGrafico(dados) {
			const LIMITE = 10000
			if (!dados || dados.length <= LIMITE) return dados || []

			const variavel = this.variavelDeInteresse
			const LARGURA_BIN = 6 // meses (0,5 ano)
			const CORTE_DP = 2.5

			const bins = new Map()
			for (const p of dados) {
				const bin = Math.floor(Number(p.idade) / LARGURA_BIN)
				if (!bins.has(bin)) bins.set(bin, [])
				bins.get(bin).push(p)
			}

			const caudas = []
			const miolos = []
			for (const pontos of bins.values()) {
				const vals = pontos.map((p) => Number(p[variavel])).filter((v) => !isNaN(v))
				const media = vals.length ? vals.reduce((a, b) => a + b, 0) / vals.length : 0
				const dp = vals.length
					? Math.sqrt(vals.reduce((a, b) => a + (b - media) * (b - media), 0) / vals.length)
					: 0

				const miolo = []
				for (const p of pontos) {
					const v = Number(p[variavel])
					const ehCauda = dp > 0 && !isNaN(v) && Math.abs(v - media) > CORTE_DP * dp
					if (ehCauda) caudas.push(p)
					else miolo.push(p)
				}
				miolos.push(miolo)
			}

			const resultado = [...caudas]
			const orcamento = Math.max(0, LIMITE - caudas.length)
			const totalMiolo = miolos.reduce((a, m) => a + m.length, 0)

			if (orcamento > 0 && totalMiolo > 0) {
				for (const miolo of miolos) {
					if (!miolo.length) continue
					let cota = Math.max(1, Math.round((miolo.length / totalMiolo) * orcamento))
					cota = Math.min(cota, miolo.length)
					const passo = miolo.length / cota
					for (let i = 0; i < cota; i++) {
						const idx = Math.min(Math.floor(i * passo), miolo.length - 1)
						resultado.push(miolo[idx])
					}
				}
			}

			return resultado
		},
		estouComSorte() {
			this.enableButton = false
			this.modeloVariavel = []
			this.item.variaveisBiometricas.forEach((f) => {
				let modelos = [
					...this.modelosPrognose.find((ff) => ff.variavelDeInteresse === f.enum)
						.analisesEstatisticas,
				].sort((a, b) => (a.stan_md_erro_porcentagem > b.stan_md_erro_porcentagem ? 1 : -1))

				this.modeloVariavel.push({
					modelo: modelos[0].stan_nm_titulo_modelo,
					variavel: f.label,
					sugerido: true,
				})
			})
		},
		async retornaVariavelModelo(event) {
			const { target } = event

			let modelo = await this.modeloVariavel.find((f) => f.variavel === target.id).modelo

			this.variavelDeInteresse = this.item.variaveisBiometricas.find(
				(f) => f.label === target.id,
			).value

			if (this.item.analisesEstatisticas) {
				this.modeloEscolhido = this.item.analisesEstatisticas
					.filter((f) => f.variavelDeInteresse === this.tipoInfoGrafico.enum)
					.map((m) => this.formataModelo(m))[0]
			} else {
				this.modelos = this.modelosDaVariavel()
				this.modeloEscolhido = this.modelos.find(
					(f) => f.stan_nm_titulo_modelo === modelo || f.stan_nm_variavel_modelo === modelo,
				)
			}
		},
		setFiltroConfig(e) {
			this.filtroConfig = e
		},
		formataModelo(modelo) {
			return {
				stan_nm_titulo_modelo: modelo.modelo,
				stan_nm_variavel_modelo: modelo.nomeModelo || modelo.stan_nm_variavel_modelo,
				stan_md_erro_porcentagem: modelo.erroPorcentagem,
				stan_md_erro: modelo.erro,
				stan_md_coeficiente_assimetria: modelo.coeficienteAssimetria,
				stan_md_coeficiente_curtose: modelo.coeficienteCurtose,
				// Object.freeze raso no gráfico salvo: ele vai para modeloEscolhido
				// (reativo) e contém realEstimado/residuo/histograma com muitos pontos —
				// sem o freeze o Vue 2 observa a subárvore inteira e estoura a memória
				// ("out of memory") ao editar/visualizar. Raso (não deepFreeze) porque o
				// gráfico muta point.x ao renderizar (pontos internos seguem mutáveis).
				graficosModelo: Object.freeze(JSON.parse(modelo.dadosDoGrafico)),
				parametros: JSON.parse(modelo.coeficientes),
				stan_nm_formula_modelo: modelo.formulaTex,
			}
		},
		async salvar() {
			this.savePlanejamentoLoading = true
			// Salvaguarda da corrida: a classificação recém-criada pode ainda não estar
			// disponível na base de prognose (sync assíncrono). O fix principal é no
			// backend (sincroniza sob demanda no salvar); aqui, se mesmo assim vier o 400
			// "classificação não encontrada", re-tenta algumas vezes com intervalo.
			const MAX_TENTATIVAS = 4
			const INTERVALO_MS = 2000
			const body = await this.preparaPlanejamento
			try {
				for (let tentativa = 1; ; tentativa++) {
					try {
						await salvarPlanejamento(body)
						break
					} catch (err) {
						if (tentativa < MAX_TENTATIVAS && this.ehErroClassificacaoNaoEncontrada(err)) {
							await new Promise((resolve) => setTimeout(resolve, INTERVALO_MS))
							continue
						}
						throw err
					}
				}
				this.mutationShowMessage({
					messageTitle: this.$t('sucesso'),
					messageText: this.$t('planejamentoRealizadoComSucesso'),
					messageIcon: 'far fa-check-circle',
					messageType: 'success',
				})
				// Salvou: o job virou planejamento — remove da central de processamentos.
				// Best-effort: falha aqui não atrapalha o fluxo (a retenção de 24h limpa).
				if (this.jobIdProcessamento) {
					excluirProcessamentoPrognose(this.jobIdProcessamento).catch((e) =>
						console.warn('Falha ao remover o job da central:', e),
					)
				}
				this.$router.push('/prognose')
			} catch (err) {
				console.error(err)
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: this.$t('erroAoSalvarModelo'),
					messageIcon: 'far fa-times-circle',
					messageType: 'error',
				})
			}
			this.savePlanejamentoLoading = false
		},
		// Detecta o 400 "Classificação de sitio não encontrada" (sync ainda não chegou).
		ehErroClassificacaoNaoEncontrada(err) {
			if (err?.response?.status !== 400) return false
			const errors = err?.response?.data?.errors ?? {}
			return JSON.stringify(errors).includes('Classificação de sitio não encontrada')
		},
		proximo() {
			this.modeln += 1
			this.modeloEscolhido = this.modelos[this.modeln]
		},
		anterior() {
			this.modeln = this.modeln - 1
			this.modeloEscolhido = this.modelos[this.modeln]
		},
		equa(event) {
			this.equacao = event
		},
		lidaEvento(event) {
			this.modeln = event
		},
		checkIdadeReferencia(value) {
			console.log(`${value} - ${value >= this.idadeMaxima}`)
			return value >= this.idadeMaxima
				? true
				: [
						false,
						`Idade de Referência deve ser maior que a idade máxima dos dados: ${this.idadeMaxima}`,
					]
		},

		fechaVisualizacaoModelo() {
			this.flag = true
			this.equacao = true
			this.modelagemStatus = true
		},
		selectedPoints(value) {
			this.parcelasTemporarias = value
			console.log(value)
		},
		setBuscando(value) {
			this.buscando = value
		},
		tipoDoGrafico(value) {
			// this.tipoInfoGrafico = value;
			this.variavelDeInteresse = value.value
		},
		removeParcelasSelecionadas() {
			// let idsy = [].concat(this.parcelasTemporarias.map(m => m.options.idAgrupamento + m.options.y ));
			let testeParcelas = []
			this.parcelasTemporarias.forEach((e) => {
				this.parcelas.forEach((o) => {
					if (o.idade === e[0] && o[this.variavelDeInteresse] === e[1]) testeParcelas.push(o)
				})
			})

			this.parcelas = Object.freeze(
				this.parcelas.filter((parcela) => !testeParcelas.includes(parcela)),
			)

			this.parcelasTemporarias = []
		},
		escolhaModelos() {
			this.modelagemStatus = false
		},
		async defineModelo() {
			this.escolherModeloLoading = true
			this.enableButton = false
			if (this.modeloVariavel.some((s) => s.variavel === this.tipoInfoGrafico.label)) {
				this.modeloVariavel.forEach((f) => {
					if (f.variavel === this.tipoInfoGrafico.label) {
						f.modelo = this.modeloEscolhido.stan_nm_titulo_modelo
						f.sugerido =
							this.modelos[0].stan_nm_titulo_modelo === this.modeloEscolhido.stan_nm_titulo_modelo
					}
				})
			}

			this.escolherModeloLoading = false
		},
		async filtrarParcelas(value) {
			let retornar = false
			if (!this.modelagemStatus || this.flag)
				retornar = confirm('Isso fará com que o processo retorne ao início')
			if (retornar) {
				this.modelagemStatus = true
				this.flag = false
				this.modelos = []
				this.modeloEscolhido = { stan_nm_variavel_modelo: 'default' }
				this.modeln = 0
				this.item.clst_nr_curvas = 5
				console.log('item: ', this.item)
			}

			// Object.freeze raso (NÃO deepFreeze): impede o Vue 2 de observar/recursar na
			// árvore de centenas de milhares de pontos. deepFreeze sobre esse volume
			// recursava em cada objeto/propriedade e estourava a memória ("out of memory")
			// já no carregar dos filtros.
			// Removido: this.item.parametros.amostras = value.map(...) — era escrito aqui
			// (cópia reativa de 100k+ objetos, outro vetor de OOM) e nunca lido; o
			// processar manda só o filtro + os outliers removidos.
			Object.freeze(value)
			this.parcelas = value
			this.parcelasBkp = value
			this.item.clst_md_limite_superior = Number(this.limiteSuperior)
			this.item.clst_md_limite_inferior = Number(this.limiteInferior)
			this.item.clst_nr_idade_referencia = ''
		},
		equac() {
			this.equacao = false
		},
		modelosDaVariavel() {
			var modelos = (this.modelosPrognose || []).find(
				(f) => f.variavelDeInteresse === this.tipoInfoGrafico.enum,
			)

			// Resultado sem a variável do gráfico (ou vazio): não quebrar a tela.
			if (!modelos?.analisesEstatisticas?.length) return []

			return [...modelos.analisesEstatisticas].sort((a, b) =>
				a.stan_md_erro_porcentagem > b.stan_md_erro_porcentagem ? 1 : -1,
			)
		},
		async processar() {
			// Guard de reentrância: se já há um job em acompanhamento (processar em
			// curso OU aberto pela central), NÃO enfileira outro. Evita o
			// reprocessamento indevido e jobs duplicados no servidor.
			if (this.processandoPrognose) return
			try {
				// Fluxo D + fila: manda só o filtro + variáveis (+ sítio) + os outliers
				// que o usuário removeu no gráfico. O worker busca os dados, ajusta em
				// fidelidade total e grava o resultado; aqui fazemos polling do job.
				const variaveis = this.item.variaveisBiometricas.map((v) => v.enum)

				let parametrizacaoSitio = null
				if (this.item.classificacaoDeSitioId) {
					const p = this.item.parametros
					parametrizacaoSitio = {
						variavelDeInteresse: p.variavelDeInteresse,
						nomeModelo: p.nomeModelo,
						idadeDeReferencia: p.idadeDeReferencia,
						numeroDeClasses: p.numeroDeClasses,
						limiteInferior: p.limiteInferior,
						limiteSuperior: p.limiteSuperior,
						coeficientes: p.coeficientes,
					}
				}

				// Outliers removidos manualmente = diff entre o original e o editado
				const outliersExcluidos = this.parcelasBkp
					.filter((p) => !this.parcelas.includes(p))
					.map((p) => ({ parcelaId: p.id, idade: p.idade }))

				const body = {
					// Identifica o job na central de processamentos.
					descricao: this.item.descricao,
					// Snapshot opaco do estado da tela: a central usa para reabrir o job
					// (restaura item/filtros e habilita o salvar) mesmo dias depois.
					// Vai como STRING pré-serializada: JsonElement no back (.NET 6)
					// quebrava ao re-serializar o request (500 no enqueue).
					contextoTelaJson: JSON.stringify({
						// Sem analisesEstatisticas: o resultado vem do próprio job, e num
						// reprocessar em modo edição esse campo carrega TODOS os
						// dadosDoGrafico (vários MB acumulando no RequestJson/localStorage).
						item: { ...this.item, analisesEstatisticas: undefined },
						filtros: this.filtros,
						filtroConfig: this.filtroConfig,
						filtroAplicado: this.filtroAplicado,
					}),
					filtro: this.filtroAplicado,
					variaveis,
					parametrizacaoSitio,
					outliersExcluidos,
					// 0 = desativa o guard de consistência. Desde que a 1ª tela passou a
					// trazer a dispersão REDUZIDA (IQR, só visual), this.parcelas não é mais
					// o total — o worker busca os dados completos e ajusta sobre eles (menos
					// as exclusões). Mandar o tamanho reduzido aqui fazia o guard acusar
					// "dados mudaram" (esperado 8000 × encontrado 197807).
					pontosEsperados: 0,
				}

				this.processandoPrognose = true
				const enq = await enfileirarProcessamentoPrognose(body)
				const jobId = enq.data?.result?.jobId ?? enq.data?.data?.jobId ?? enq.data?.jobId
				this.jobIdProcessamento = jobId

				const dados = await this.aguardarResultadoPrognose(jobId)
				if (dados === undefined) return // tela destruída (polling cancelado)
				this.aplicarResultadoProcessamento(dados)
			} catch (error) {
				console.log(error)
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: error?.message || this.$t('erroAoProcessarPrognose'),
					messageIcon: 'far fa-times-circle',
					messageType: 'error',
				})
			} finally {
				this.processandoPrognose = false
			}
		},
		// Aplica o resultado do job na tela (usado pelo processar e pela retomada
		// via central de processamentos).
		aplicarResultadoProcessamento(dados) {
			// Resultado vazio/sem modelos (ex.: filtro trouxe poucos dados, nenhum
			// modelo convergiu): avisa e NÃO aplica — evita quebrar a tela toda
			// (modelosDaVariavel/ModelPreview acessando modelo inexistente).
			if (!Array.isArray(dados) || !dados.length) {
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: this.$t('processamentoSemModelos'),
					messageIcon: 'far fa-times-circle',
					messageType: 'error',
				})
				return
			}
			this.modelagemStatus = false
			this.loading = true
			this.equacao = false
			// Object.freeze raso (não deepFreeze): evita o Vue 2 observar a árvore
			// grande (perf), mas mantém os pontos aninhados mutáveis — o componente
			// de gráfico (RealEstimado/CardGrafico) muta point.x ao renderizar, e
			// deepFreeze causava "TypeError: x is read-only".
			this.modelosPrognose = Object.freeze(dados)
			this.modelos = this.modelosDaVariavel()
			this.modeloEscolhido = this.modelos[0]
			this.variavelDeInteresse = this.item.variaveisBiometricas[0].value
			this.prognoseSemClassificacaoDeSitioAtrelada = false
			this.estouComSorte()
		},
		// Retomada via central de processamentos (?jobId=...): volta a acompanhar um
		// job em andamento — ou carrega direto o resultado de um job já concluído.
		async retomarProcessamento(jobId) {
			// Restaura o restante do contexto que o salvar precisa (filtroConfig etc.),
			// deixado pela central junto com o item (chave consumida e removida aqui).
			try {
				const ctx = JSON.parse(localStorage.getItem('contexto-processamento-prognose') || 'null')
				if (ctx) {
					this.filtros = ctx.filtros ?? this.filtros
					this.filtroConfig = ctx.filtroConfig ?? this.filtroConfig
					this.filtroAplicado = ctx.filtroAplicado ?? this.filtroAplicado
					localStorage.removeItem('contexto-processamento-prognose')
				}
			} catch (e) {
				console.warn('Contexto do processamento ilegível, seguindo sem ele:', e)
			}

			this.processandoPrognose = true
			this.jobIdProcessamento = jobId
			try {
				const dados = await this.aguardarResultadoPrognose(jobId)
				if (dados === undefined) return // tela destruída (polling cancelado)
				this.aplicarResultadoProcessamento(dados)
			} catch (error) {
				console.error('Erro ao retomar processamento:', error)
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: error?.message || this.$t('erroAoProcessarPrognose'),
					messageIcon: 'far fa-times-circle',
					messageType: 'error',
				})
			} finally {
				this.processandoPrognose = false
			}
		},
		// Faz polling do job até concluir/falhar. O resultado vem como JSON (string)
		// no campo resultado; devolve o array de modelos por variável.
		async aguardarResultadoPrognose(jobId) {
			const intervaloMs = 3000
			// ~20 min: o worker agora também renderiza as imagens dos gráficos grandes
			// (1 processo R por variável) durante o processamento.
			const maxTentativas = 400
			// Uma falha de rede transitória (Wi-Fi, 502/504 do gateway, refresh de
			// token) NÃO pode abortar a espera: o job continua rodando no back e o
			// usuário perderia um resultado de ~20 min. Só desiste depois de várias
			// falhas consecutivas (~1,5 min sem conseguir consultar o status).
			const maxFalhasConsecutivas = 10
			let falhasConsecutivas = 0
			this.progressoJob = { etapa: null, renderFeitos: 0, renderTotal: 0 }
			for (let i = 0; i < maxTentativas; i++) {
				// Tela destruída: para o polling (o job segue no back e pode ser
				// retomado pela central). undefined = cancelado (array = resultado).
				if (this.pollingCancelado) return undefined
				try {
					const resp = await statusProcessamentoPrognose(jobId)
					const job = resp.data?.result ?? resp.data?.data ?? resp.data
					// Alimenta o painel de progresso (etapa do worker + contador do render).
					this.progressoJob = {
						etapa: job?.etapa ?? null,
						renderFeitos: job?.renderFeitos ?? 0,
						renderTotal: job?.renderTotal ?? 0,
					}
					if (job?.status === 'Concluido') {
						return job.resultado ? JSON.parse(job.resultado) : []
					}
					if (job?.status === 'Falhou') {
						throw new Error(job.erro || this.$t('erroAoProcessarPrognose'))
					}
					falhasConsecutivas = 0
				} catch (erro) {
					// Job inexistente (removido após salvar / expirado / id inválido): o
					// endpoint responde 4xx "não encontrado". NÃO é falha transitória —
					// aborta já, sem ficar ~1,5min tentando e mascarando de "processando".
					const statusHttp = erro?.response?.status
					if (statusHttp === 404 || statusHttp === 400) {
						throw new Error(this.$t('processamentoNaoEncontrado'))
					}
					// Erro do JOB (status Falhou) aborta na hora; falha da CONSULTA
					// (rede/gateway) conta para o limite e tenta de novo.
					if (!erro?.isAxiosError && !erro?.request) throw erro
					falhasConsecutivas++
					if (falhasConsecutivas >= maxFalhasConsecutivas) throw erro
				}
				await new Promise((resolve) => setTimeout(resolve, intervaloMs))
			}
			throw new Error(this.$t('tempoDeProcessamentoExcedido'))
		},
	},
	components: {
		Card,
		Button,
		Filtragem,
		ScatterChart,
		ModelPreview,
		Tag,
		Tooltip,
		AboutModel,
		Spinner,
	},
}
</script>

<style scoped>
/* Overlay flutuante (position fixed): NÃO participa do fluxo do layout — a
   barra aparecer/sumir não pode empurrar gráfico e botões para baixo. */
.progresso-job {
	position: fixed;
	top: 84px;
	right: 24px;
	z-index: 1000;
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 14px;
	border: 1px solid #d7e3c5;
	border-radius: 8px;
	background-color: #f6faee;
	box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
}

.progresso-job__spinner {
	flex: 0 0 auto;
	transform: scale(0.6);
}

.progresso-job__info {
	display: flex;
	flex-direction: column;
	gap: 3px;
	min-width: 260px;
}

.progresso-job__titulo {
	font-weight: 700;
	font-size: 13px;
	color: #4a6320;
}

.progresso-job__etapa {
	font-size: 12px;
	color: #666;
}

.progresso-job__barra {
	height: 6px;
	border-radius: 3px;
	background-color: #e4e9da;
	overflow: hidden;
}

.progresso-job__barra-preenchida {
	height: 100%;
	border-radius: 3px;
	background-color: #95bb49;
	transition: width 0.6s ease;
}

.badge__amostra {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	padding: 1px 8px;
	border-radius: 10px;
	background-color: #fff4e5;
	color: #8a5a00;
	border: 1px solid #ffd599;
	font-size: 11px;
	font-weight: 600;
	line-height: 1.6;
	white-space: nowrap;
	cursor: help;
}

.container__button__classificar {
	width: auto;
	bottom: 0;
	left: 0;
	right: 0;
	margin-bottom: 1rem;
	padding: 0 1rem;
}

.campos__parametrizacao {
	margin-top: 2rem;
	position: relative;
}

.container__card.container__dashboard__contentbody__card {
	margin: 0;
	display: flex;
	flex-direction: column;
}
.btnVoltar {
	width: auto;
}
.container__compo_botao {
	display: flex;
}
.divBubble {
	text-align: end;
	position: inherit;
	margin-left: -70px;
}
.model__preview_actions {
	padding: 0.8rem;
	display: flex;
	align-content: center !important;
}
.container__histogramas__sitio {
	display: flex;
	flex-direction: row;
	height: 100%;
}

.container__registers {
	padding: 0.8rem;
	height: 90vh;
}

.btnnn {
	align-content: center;
}

.btnnn:active {
	background-color: #0b0e25;
	transform: translateY(-1px);
}

.container__main {
	display: grid;
	width: 100%;
	height: 100%;
	max-height: 100%;
	gap: 0.5rem;
	margin-top: 0.5rem;
	/* justify-content: space-between; */
	grid-template-columns: 1fr 3fr 1fr;
}
.action__buttons_right,
.action__buttons_left {
	display: flex;
	gap: 0.5rem;
}

.container__card__custom.steps {
	max-height: 3rem;
	background: none;
}

.v-stepper__header {
	height: 3rem;
}

.v-stepper__step {
	padding: 0.5rem 0.8rem;
}

.v-devider {
	padding: 0 1rem;
}

.model__preview__container {
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
	justify-content: space-between;
}
.container__cardgrafico.main__parcels__chart {
	height: 100%;
}

.container__dropdown__label {
	margin-bottom: 0 !important;
}

.v-window__container {
	width: 100% !important;
	height: 95% !important;
}

.ui.button {
	padding: 8px 15px;
}

.action__buttons {
	padding: 0 0 0.5rem 0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.ccontainer__checkbox {
	padding: 0.5rem 0;
}

.card_variavel_modelo {
	padding: 0.5rem;
	margin: 0.8rem;
	cursor: pointer;
}

.tag_cabecalho_modelo {
	margin: 0.5rem;
}

.info_planejamento_prognose {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	width: 22vw;
}

.info_classificacao_de_sitio {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 1rem;
	width: 22vw;
}

.info_classificacao_de_sitio_title {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	text-align: center;
	color: rgb(var(--color-primary));
	font-size: 1.2rem;
	font-weight: 700;
	margin: 1rem 1rem 0 1rem;
}

.info_classificacao_de_sitio_subtitle {
	font-size: 1rem;
	font-weight: 700;
	color: rgb(var(--color-primary));
	margin: 1rem 1rem 0.5rem 0.5rem;
	display: flex;
}

.info_classificacao_de_sitio_subtitle > label {
	margin-right: 0.5rem;
}

.info_classificacao_de_sitio_details {
	display: flex;
	flex-direction: column;
}

.info_classificacao_de_sitio_info {
	display: flex;
	flex-direction: column;
	max-height: 12rem;
	overflow: auto;
}

.info_classificacao_de_sitio_info label {
	font-size: 0.9rem;
	margin-bottom: 0;
	text-align: left;
	font-weight: 700;
	margin: 0.2rem 1rem;
}

.info_classificacao_de_sitio_info label span {
	font-size: 0.9rem;
	margin-bottom: 0;
	text-align: left;
	font-weight: 500;
}

.sem-relacao {
	margin: 0 auto;
}

.v-tab {
	text-transform: none !important;
	font-family: 'Open Sans';
}

.title_planning {
	font-size: 1rem;
	font-weight: 700;
	color: rgb(var(--color-primary));
}

.container__cards__variavel__modelo {
	height: 100%;
	max-height: 73vh;
	overflow: auto;
}

.tag__modelo__sugerido {
	font-size: 0.6rem;
	margin-bottom: 0.5rem;
	text-transform: uppercase;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
	.relacao__variavel__modelo {
		font-size: 0.75rem;
	}

	.container__button__classificar {
		margin-bottom: 1.8rem;
	}

	.model__preview__container {
		justify-content: none;
	}
}
</style>
